import Header from "@/components/Header";
import Footer from "@/components/Footer";

const POSTS = [
  {
    id: 1,
    category: "Investing",
    date: "June 10, 2026",
    title: "How NRIs Can Maximise Returns with AI-Driven Portfolios",
    image: "https://images.unsplash.com/photo-1768224656445-33d078c250b7?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
    excerpt:
      "Discover how machine learning models analyse thousands of market signals to keep your portfolio optimised around the clock.",
  },
  {
    id: 2,
    category: "Tax & Compliance",
    date: "May 28, 2026",
    title: "NRE vs NRO Accounts: What Every NRI Investor Must Know",
    image: "https://images.unsplash.com/photo-1764087957302-ef0756ed8e0a?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
    excerpt:
      "A plain-language breakdown of the key differences, tax implications, and which account type suits your investment goals.",
  },
  {
    id: 3,
    category: "Market Insights",
    date: "May 14, 2026",
    title: "India's Real Estate Boom: Opportunities for the Diaspora",
    image: "https://images.unsplash.com/photo-1773470920361-4f6cbb702ce0?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
    excerpt:
      "Property markets in Tier-1 and Tier-2 cities are heating up. Here's how NRIs can participate safely and profitably.",
  },
  {
    id: 4,
    category: "Wealth Planning",
    date: "April 30, 2026",
    title: "Building a Cross-Border Wealth Strategy That Actually Works",
    image: "https://images.unsplash.com/photo-1771998785227-268f33b50c65?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
    excerpt:
      "Balancing assets across multiple currencies and jurisdictions requires more than intuition — it needs a system.",
  },
  {
    id: 5,
    category: "Investing",
    date: "April 15, 2026",
    title: "Mutual Funds for NRIs: A Step-by-Step Beginner's Guide",
    image: "https://images.unsplash.com/photo-130243820/pexels-photo-30243820.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600&q=80",
    excerpt:
      "From KYC requirements to choosing the right fund category, everything you need to start your mutual fund journey from abroad.",
  },
  {
    id: 6,
    category: "Tax & Compliance",
    date: "March 28, 2026",
    title: "DTAA Benefits: How to Avoid Double Taxation as an NRI",
    image: "https://images.unsplash.com/photo-1743136648358-5e30aa46950e?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
    excerpt:
      "India's Double Tax Avoidance Agreements with 90+ countries can save you significant money — if you know how to use them.",
  },
];

export default function Blog() {
  return (
    <div className="min-h-screen bg-[hsl(var(--zt-beige))] flex flex-col">
      <Header />

      <main className="flex-1 pt-36 pb-24 px-6 md:px-12 lg:px-16 max-w-[1400px] mx-auto w-full">
        {/* Editorial Page Header */}
        <div className="mb-16 pb-8 border-b border-[hsl(var(--zt-teal))]/10 max-w-4xl space-y-4">
          <div className="flex items-center gap-3">
            <span className="gold-rule w-10" />
            <span className="text-[11px] font-heading font-semibold text-[hsl(var(--zt-teal))]/75 uppercase tracking-[0.25em]">Zenstrust Insights</span>
          </div>
          
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl text-[hsl(var(--zt-teal))] leading-tight font-bold tracking-tight">
            Insights for the <span className="text-[hsl(var(--zt-gold))] gold-text-glow font-display italic font-semibold">global Indian</span> investor
          </h1>
          <p className="mt-3 text-[hsl(var(--zt-charcoal))]/70 max-w-2xl text-sm lg:text-base leading-relaxed font-body">
            Strategic perspectives on cross-border wealth structure, regulatory governance, and tax optimization mechanisms—crafted in clean, simplified prose.
          </p>
        </div>

        {/* Luxury Magazine Post Grid */}
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {POSTS.map((post) => (
            <article
              key={post.id}
              className="group flex flex-col bg-white/60 hover:bg-white border border-[hsl(var(--zt-beige-deep))] rounded-3xl overflow-hidden p-5 transition-all duration-500 hover:-translate-y-1.5 hover:border-[hsl(var(--zt-gold))]/35 hover:shadow-[0_25px_60px_-20px_rgba(16,24,40,0.15)] cursor-pointer"
            >
              {/* Blog Post Cover Image */}
              <div className="aspect-[16/10] rounded-2xl overflow-hidden mb-6 relative border border-[hsl(var(--zt-teal))]/5">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  onError={(e) => {
                    // Fallback to gradient if image fails
                    e.target.style.display = "none";
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--zt-teal))]/10 via-transparent to-transparent pointer-events-none" />
              </div>

              <div className="flex items-center justify-between mb-4 px-1">
                <span className="text-[9px] font-heading font-bold text-[hsl(var(--zt-teal))] bg-[hsl(var(--zt-teal))]/5 border border-[hsl(var(--zt-teal))]/10 px-2.5 py-1 rounded-full uppercase tracking-wider">
                  {post.category}
                </span>
                <span className="text-[10px] text-[hsl(var(--zt-charcoal))]/60 font-heading font-semibold">{post.date}</span>
              </div>

              <h2 className="text-lg font-heading font-bold text-[hsl(var(--zt-teal))] leading-snug group-hover:text-[hsl(var(--zt-gold))] transition-colors duration-300 px-1 mb-3">
                {post.title}
              </h2>
              
              <p className="text-sm text-[hsl(var(--zt-charcoal))]/75 leading-relaxed font-body flex-1 px-1 mb-5">
                {post.excerpt}
              </p>

              <span className="text-[11px] font-heading font-bold text-[hsl(var(--zt-teal))]/60 group-hover:text-[hsl(var(--zt-gold))] transition-colors duration-300 self-start px-1 flex items-center gap-1.5 uppercase tracking-wider">
                Read article <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
              </span>
            </article>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
